<template>
  <v-card v-if="draftApplications" flat>
    <h1>{{ $t("application.draft.title") }}</h1>
    <h4>{{ $t("application.draft.info") }}</h4>

    <!-- Application List start here -->
    <v-expansion-panels class="mt-4">
      <v-expansion-panel
        v-for="(item, index) in draftApplications"
        :key="index"
        :aria-label="$t('labels.existing-applications')"
      >
        <v-expansion-panel-header expand-icon="$sl-arrow-down">
          <div>
            <div class="header-title">{{ item.state.name }}</div>
            <div class="header-sub-title">
              {{ $t("application.list-changed") }} {{ item.createdAt | date }}
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <h6>{{ $t("application.list-draft") }}</h6>
          <p>{{ item.createdAt | date }}</p>
          <h6>{{ $t("application.list-saved") }}</h6>
          <p>{{ item.updatedAt | date }}</p>
          <template v-if="checkHasNotifications(item)">
            <h6>{{ $t("application.list-notification") }}</h6>
            <template v-if="checkHasNotifications(item)">
              <h6 class="mb-1">{{$t('application.list-notification')}}</h6>
              <div v-for="notification in item.notifications" :key="notification.id">
                <div v-if="notification.text != ''">
                  <p class="message-title">
                    {{ getNotification(notification)}}
                    <span
                        class="message-date"
                    >({{notification.sentTime | date}})</span>
                  </p>
                  <p v-html="notification.text"></p>
                </div>
              </div>
            </template>
          </template>

          <div v-if="isCompanyUser(compId)">
            <ActionButton
              type="application"
              actionIcon="$sl-arrow-right"
              :isDisabled="
                !(item.stateId === companyDraftStateId && item.isCompanyApplication) || isImitatingUser()
              "
              @click="
                item.stateId === companyDraftStateId ? $emit('open', item.id) : nada
              "
              >{{ $t("application.list-continueBtn") }}</ActionButton
            >
          </div>
          <div v-else>
            <ActionButton
              actionIcon="$sl-arrow-right"
              flat
              class="mt-3"
              :isDisabled="
                !(
                  item.stateId == apprenticeDraftStateId ||
                  (item.stateId == apprenticeDraftStateId && item.isCompanyApplication) ||
                  item.stateId == confirmedByCompany
                ) || isImitatingUser()
              "
              @click="
                item.stateId === apprenticeDraftStateId || item.isCompanyApplication
                  ? $emit('open', { id: item.id, isCompany: item.isCompanyApplication })
                  : nada
              "
              type="application"
              >{{ $t("application.list-continueBtn") }}</ActionButton
            >
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- Application List ends here -->
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import find from "lodash/find";
import ActionButton from "@/components/Common/ActionButton";

// @group Applications/Common
// ApprenticeListDraft component
export default {
  name: "ApplicationListDraft",

  props: {
    // The draft Applications props
    draftApplications: {
      // `'Array'`
      type: Array,
      // `'Array'`
      default: () => [],
    },
    compId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ActionButton,
  },
  computed: {
    ...mapGetters("currentuser", [
      "currentUser",
      "isApprentice",
      "isInstructor",
      "isCompanyUser",
      "isImitatingUser",
    ]),
    ...mapGetters("application", ["currentStep"]),
    ...mapGetters("basic", [
      "apprenticeDraftStateId",
      "companyDraftStateId",
      "basicProfessions",
      "confirmedByCompany",
    ]),
  },
  mounted() {
    this.$scrollToTop();
  },
  methods: {
    /**
     * @vuese
     * Used to check if the application has messages and returm if any
     * @arg The argument is an object representing application
     */
    getNotification(notification) {
      var ret = ''
      if (notification.fromName && notification.fromName != '') {
        if (notification.fromName == notification.toName) {
          ret =
              this.$t('application.instructor.date.date-from') +
              ' BYN ' +
              this.$t('application.instructor.date.date-to2') +
              ' ' +
              notification.toName
        } else {
          ret = this.$t('application.instructor.date.date-from') + ' ' + notification.fromName

          if (notification.toName && notification.toName != '') {
            ret += ' ' + this.$t('application.instructor.date.date-to2') + ' ' + notification.toName
          }
        }
      } else if (notification.toName && notification.toName != '') {
        ret = this.$t('application.instructor.date.date-to') + ' ' + notification.toName
      }
      return ret
    },
    checkHasNotifications(item) {
      if (item && item.notifications && item.notifications.length > 0) {
        let result = find(item.notifications, (o) => o.text != "");
        if (result) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
};
</script>

<style scoped></style>
